export default __webpack_public_path__ + "static/media/page4.e696641f.webp";